import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#calendar_svg__a)">
      <path d="M19.99 21H4.01C2.9 21 2 20.1 2 18.99V6.01C2 4.9 2.9 4 4.01 4h15.98C21.1 4 22 4.9 22 6.01v12.98c0 1.11-.9 2.01-2.01 2.01M4.01 6v12.99H20V6.01H4.01z" />
      <path d="M20.86 10H3.1c-.55 0-1-.45-1-1s.45-1 1-1h17.76c.55 0 1 .45 1 1s-.45 1-1 1M7 7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1M17 7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="calendar_svg__a">
        <path fill="#fff" d="M2 3h20v18H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCalendar;
